export default {
  setSuperUsers(state, payload) {
    state.superUsers = payload;
  },
  setSearchResultUser(state, payload) {
    state.searchResultUser = payload;
  },
};
